import {clsx} from 'clsx'
import {type ComponentPropsWithoutRef, forwardRef} from 'react'

import styles from './header-grid-cell-layout.module.css'

export const HeaderGridCellLayout = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<'div'>>((props, ref) => {
  const {children, className, ...otherProps} = props
  return (
    <div className={clsx(className, styles.Box)} {...otherProps} ref={ref}>
      {children}
    </div>
  )
})

HeaderGridCellLayout.displayName = 'HeaderGridCellLayout'
